export default __webpack_public_path__ + "static/media/icon-photo-placeholder.8e924603.svg";